import React, { useEffect, useState } from "react";
import Navbar2 from "../Components/Navbar2";
import Footer2 from "../Components/Footer2";
import Aos from "aos";
import { getCloudLabs } from "../Common/apis";
import Loader from "../Loader/Loader";

function ClodeLab() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    Aos.init({
      duration: 1000, // animation duration in ms
      once: true // animate only once
    });
  }, []);

  useEffect(() => {
    const fetchService = async () => {
      try {
        setLoading(true);
        const res = await getCloudLabs();
        setData(res.data);
      } catch (err) {
        console.error("Error fetching service:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchService();
  }, []);

  return (
    <>
      <div className="new-home">
        <Navbar2 />
        {loading && <Loader />}
        <div className="flex md:flex-row flex-col justify-between xl:pl-[80px] lg:pl-[40px] pl-[20px] md:gap-0 gap-[50px] items-center xl:pr-[153px] lg:pr-[40px] pr-[20px] mt-[38px]">
          <div>
            <img
              data-aos="flip-up"
              src="/assets/train/item5.svg"
              className="xl:h-auto lg:h-[150px] md:h-[140px]"
              alt=""
            />
          </div>
          <div data-aos="fade-up" className="c-box">
            <h6 className="md:max-w-[350px] max-w-[246px] font-[500] w-full font-sans xl:text-[20px] lg:text-[20px] md:text-[14px] text-[20px] md:leading-[28px] leading-[32px] mx-auto text-[#6953A3] md:pt-[44px] pt-[44px] text-center md:pb-[12px] pb-[8px]">
              Why just learn when you can experience?{" "}
            </h6>
            <p className="lg:max-w-[350px] md:max-w-[330px] max-w-[245px] w-full mx-auto text-center font-sans xl:text-[16px] md:text-[14px] text-[11px] font-[400] text-[#6953A3]">
              GISUL’s Cloud Labs bring you an immersive, hands-on training
              environment that feels just like the real world—without the risks!
              Gain industry-ready skills, experiment with cutting-edge tools,
              and solve real-world challenges in a secure, dynamic, and
              interactive setting.
            </p>
          </div>
        </div>
        <div className="grid xl:grid-cols-2 grid-cols-1 xl:gap-[218px] xl:items-start items-center gap-[38px] md:px-[150px] px-[20px]">
          <div className="md:pt-[50px] pt-0 cloud-list">
            <div className="relative z-10 pl-[26px] pt-[26px] flex flex-col gap-[20px]">
              {data?.length > 0 ? (
                data.map((item, index) => (
                  <div
                  key={item._id || index}
                  data-aos="fade-up"
                  className="flex items-center"
                  >
                    <img src="/assets/train/item7.svg" alt="" />
                    <button className="max-w-[280px] w-full border-[3px] border-[#6953A3] text-center bg-[#FFFFFF] rounded-full py-[24px] font-sans md:text-[24px] text-[16px] font-[500] md:leading-[29px] leading-[22px] text-[#000000] ml-[-12px]">
                      {item.title}
                    </button>
                  </div>
                ))
              ) : (
                <p className="text-[#6953A3] text-center">No data available</p>
              )}
              {/* <div data-aos="fade-up" className="flex items-center">
                <img src="/assets/train/item7.svg" alt="" />
                <button className="max-w-[280px] w-full border-[3px] border-[#6953A3] text-center bg-[#FFFFFF] rounded-full py-[24px] font-sans md:text-[24px] text-[16px] font-[500] md:leading-[29px] leading-[22px] text-[#000000] ml-[-12px]">
                  Real-World Scenarios
                </button>
              </div> */}
              {/* <div data-aos="fade-up" className="flex items-center">
                <img src="/assets/train/item7.svg" alt="" />
                <button className="max-w-[280px] w-full border-[3px] border-[#6953A3] text-center bg-[#FFFFFF] rounded-full py-[24px] font-sans md:text-[24px] text-[16px] font-[500] md:leading-[29px] leading-[22px] text-[#000000] ml-[-12px]">
                  Access to Advanced Tools
                </button>
              </div>
              <div data-aos="fade-up" className="flex items-center">
                <img src="/assets/train/item7.svg" alt="" />
                <button className="max-w-[280px] w-full border-[3px] border-[#6953A3] text-center bg-[#FFFFFF] rounded-full py-[24px] font-sans md:text-[24px] text-[16px] font-[500] md:leading-[29px] leading-[22px] text-[#000000] ml-[-12px]">
                  Scalable Learning Environment
                </button>
              </div>
              <div data-aos="fade-up" className="flex items-center">
                <img src="/assets/train/item7.svg" alt="" />
                <button className="max-w-[280px] w-full border-[3px] border-[#6953A3] text-center bg-[#FFFFFF] rounded-full py-[24px] font-sans md:text-[24px] text-[16px] font-[500] md:leading-[29px] leading-[22px] text-[#000000] ml-[-12px]">
                  Cost-Effective Learning
                </button>
              </div>
              <div data-aos="fade-up" className="flex items-center">
                <img src="/assets/train/item7.svg" alt="" />
                <button className="max-w-[280px] w-full border-[3px] border-[#6953A3] text-center bg-[#FFFFFF] rounded-full py-[24px] font-sans md:text-[24px] text-[16px] font-[500] md:leading-[29px] leading-[22px] text-[#000000] ml-[-12px]">
                  Hands-On Practical Training
                </button>
              </div>
              <div data-aos="fade-up" className="flex items-center">
                <img src="/assets/train/item7.svg" alt="" />
                <button className="max-w-[280px] w-full border-[3px] border-[#6953A3] text-center bg-[#FFFFFF] rounded-full py-[24px] font-sans md:text-[24px] text-[16px] font-[500] md:leading-[29px] leading-[22px] text-[#000000] ml-[-12px]">
                  24/7 Access
                </button>
              </div>
              <div data-aos="fade-up" className="flex items-center">
                <img src="/assets/train/item7.svg" alt="" />
                <button className="max-w-[280px] w-full border-[3px] border-[#6953A3] text-center bg-[#FFFFFF] rounded-full py-[24px] font-sans md:text-[24px] text-[16px] font-[500] md:leading-[29px] leading-[22px] text-[#000000] ml-[-12px]">
                  Secure and Reliable Environment
                </button>
              </div>
              <div data-aos="fade-up" className="flex items-center">
                <img src="/assets/train/item7.svg" alt="" />
                <button className="max-w-[280px] w-full border-[3px] border-[#6953A3] text-center bg-[#FFFFFF] rounded-full py-[24px] font-sans md:text-[24px] text-[16px] font-[500] md:leading-[29px] leading-[22px] text-[#000000] ml-[-12px]">
                  Cross-Platform Compatibility
                </button>
              </div> */}
            </div>
          </div>
          <div className="flex justify-center items-center">
            <img data-aos="flip-up" src="/assets/train/item8.svg" alt="" />
          </div>
        </div>

        {/* <div className='train'>
          <div className='train-left'>
            <img src={img} />

          </div>
          <div className='train-right'>
            <div className='idea-box'>

            </div>
            <img src={img2} />

          </div>
        </div> */}
        <Footer2 />
      </div>
    </>
  );
}

export default ClodeLab;
